const planStatuses = Object.freeze({ deny: -1, selected: 0, allow: 1 });

export default planStatuses;
